
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import Index from "./pages/Index";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import { ProductDetailProvider } from "./contexts/ProductDetailContext";
import { ProductDetailSheet } from "./components/ProductDetailSheet";
import ProductDetailPage from "./pages/ProductDetailPage";
import { BackToTop } from "./components/BackToTop";
import { OrderConfirmationSheet } from "./components/order/OrderConfirmationSheet";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider defaultTheme="system" storageKey="pharmacare-theme">
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <ProductDetailProvider>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
            </Routes>
            <ProductDetailSheet />
            <OrderConfirmationSheet />
            <BackToTop />
          </ProductDetailProvider>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
